// Keep the full-screen navigation isolated from the page it covers.
export function containMobileMenuFocus(header, toggle, close) {
  const document = header.ownerDocument;
  const window = document.defaultView;
  const desktop = window.matchMedia("(min-width: 701px)");
  if (desktop.matches) return () => {};

  const outside = [];
  for (let branch = header; branch.parentElement; branch = branch.parentElement) {
    for (const sibling of branch.parentElement.children) {
      if (sibling === branch || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) continue;
      outside.push([sibling, sibling.hasAttribute("inert")]);
      sibling.setAttribute("inert", "");
    }
    if (branch.parentElement === document.body) break;
  }
  const controls = () => [...header.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')]
    .filter((element) => !element.closest("[inert]") && element.getClientRects().length > 0);
  const focusToggle = () => toggle.focus({ preventScroll: true });
  const onKeyDown = (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      close();
    } else if (event.key === "Tab") {
      const items = controls();
      const first = items[0];
      const last = items.at(-1);
      if (!items.includes(document.activeElement)
        || (event.shiftKey && document.activeElement === first)
        || (!event.shiftKey && document.activeElement === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first)?.focus();
      }
    }
  };
  const onFocus = (event) => {
    if (!header.contains(event.target)) focusToggle();
  };
  const onBreakpoint = () => { if (desktop.matches) close(); };
  document.addEventListener("keydown", onKeyDown, true);
  document.addEventListener("focusin", onFocus);
  desktop.addEventListener("change", onBreakpoint);
  focusToggle();

  return () => {
    document.removeEventListener("keydown", onKeyDown, true);
    document.removeEventListener("focusin", onFocus);
    desktop.removeEventListener("change", onBreakpoint);
    for (const [element, wasInert] of outside) {
      if (!wasInert) element.removeAttribute("inert");
    }
    if (toggle.isConnected && toggle.getClientRects().length) focusToggle();
    else if (header.isConnected && header.contains(document.activeElement)) header.querySelector("a[href]")?.focus();
  };
}
